import { useEffect, useRef, useState } from 'react';

/**
 * Reads the live column count off a CSS grid element, so the breakpoints
 * stay owned by CSS instead of being duplicated in JS. Returns a ref to
 * attach to the grid container, and the current number of columns it's
 * rendering (1 when disabled or not yet measured).
 */
const useGridColumnCount = (enabled: boolean) => {
  const ref = useRef<HTMLDivElement>(null);
  const [columnCount, setColumnCount] = useState(1);

  useEffect(() => {
    if (!enabled || !ref.current) return undefined;

    const element = ref.current;
    const updateColumnCount = () => {
      const tracks = window.getComputedStyle(element).gridTemplateColumns.split(' ').filter(Boolean);
      setColumnCount(tracks.length || 1);
    };

    updateColumnCount();
    const observer = new ResizeObserver(updateColumnCount);
    observer.observe(element);

    return () => observer.disconnect();
  }, [enabled]);

  return { ref, columnCount };
};

export default useGridColumnCount;
